interface TokenResponse {
  access_token: string;
  id_token: string;
  token_type: string;
  expires_in: number;
  refresh_token?: string;
}

interface UserClaims {
  sub: string;
  email?: string;
  cognito_groups?: string[];
  [key: string]: unknown;
}

export const exchangeCodeForTokens = async (code: string): Promise<TokenResponse> => {
  const clientId = import.meta.env.REACT_APP_USER_POOL_WEB_CLIENT_ID ?? '';
  const redirectUri = `${window.location.origin}/callback`;

  let tokenEndpoint: string;

  // Check if we're using LocalStack
  const isLocalStack = import.meta.env.REACT_APP_ENVIRONMENT_TYPE === 'local';

  if (isLocalStack) {
    // LocalStack token endpoint using direct localhost access
    tokenEndpoint = 'http://localhost:4566/_aws/cognito-idp/oauth2/token';
  } else {
    // Use real AWS Cognito
    const domain_prefix = import.meta.env.REACT_APP_COGNITO_DOMAIN_PREFIX;
    const region = import.meta.env.REACT_APP_REGION;
    tokenEndpoint = `https://${domain_prefix}.auth.${region}.amazoncognito.com/oauth2/token`;
  }

  const params = new URLSearchParams();
  params.append('grant_type', 'authorization_code');
  params.append('client_id', clientId);
  params.append('redirect_uri', redirectUri);
  params.append('code', code);

  const response = await fetch(tokenEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString(),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to exchange code for tokens: ${response.status} ${errorText}`);
  }

  return await response.json();
};

export const parseJwt = (token: string): UserClaims => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return { sub: '' };
  }
};
